/**
 * @description product getters
 */

export default {
  skuList(state) {
    return state.skuList
  }
  , skuDetail(state) { // 单品详情
    return state.skuDetail
  }
  // 支付方式
  , payMethodList(state) {
    return state.payMethodList
  }
  , paymentSubCode(state) {
    return state.paymentSubCode
  }
  , paySelectedIndex(state) {
    return state.paySelectedIndex
  }
  , secondPayMethodsList(state) {
    return state.secondPayMethodsList
  }
  // 订单列表
  , orderList(state) {
    return state.orderList
  }
  // 商品价格信息
  , priceInfo(state, getters) {
    // 获取选中优惠券或优惠码信息
    const {selectedCoupon} = getters
    const product = state.skuDetail
    if (product) {
      const {sellingPrice, marketPrice} = product
      let sum = 1 * sellingPrice
      let save = 1 * (marketPrice - sellingPrice)
      let tempSum = sum
      switch (selectedCoupon.couponMode) {
        case 'Cash':
          // 转换为数字
          sum -= (1 * (selectedCoupon.discountFee || selectedCoupon.amountMax))
          save += (1 * (selectedCoupon.discountFee || selectedCoupon.amountMax))
          break
        case 'Discount':
          sum = sum * selectedCoupon.amountMax * 0.1
          save += tempSum * (1 - (selectedCoupon.amountMax * 0.1))
          break
      }
      return {sum: sum, save: save}
    }
  }
}
